
	 
    import { Options, Vue  } from "vue-class-component";  
     
    @Options({
        name: "AlunoIndex",
        components: {    },  
    }) 
    export default class AlunoIndex extends Vue {
         
    }
  
